import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { blue, grey, red } from "@mui/material/colors";
import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { post, validateEmail } from "../../utils/io";

function NewOrganization() {
  const [input, setInput] = useState({
    requestor_first_name: "",
    requestor_last_name: "",
    requestor_email: "",
    org_alias: "",
    org_name: "",
  });
  const [errEmail, setErrEmail] = useState("");
  const [errOrgAlias, setErrOrgAlias] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [isRequesting, setIsRequesting] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);

  const validateOrgAlias = (value) => value && /^[a-z0-9-]{1,20}$/.test(value);

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    const formatOrgAlias = (val) =>
      val
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        .slice(0, 20);

    if (name === "requestor_email") {
      const isvalidEmail = validateEmail(value);
      setErrEmail(!isvalidEmail ? "Invalid email address" : "");
    }
    if (name === "org_alias") {
      const isValidOrgAlias = validateOrgAlias(value);
      setErrOrgAlias(!isValidOrgAlias);
    }
    setInput((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "org_name" && { org_alias: formatOrgAlias(value) }),
    }));
  };

  /* eslint-disable camelcase */
  const disableButtonSubmit = () => {
    const {
      requestor_first_name,
      requestor_last_name,
      requestor_email,
      org_alias,
      org_name,
    } = input;
    const isvalidEmail = validateEmail(requestor_email);
    const isValidOrgAlias = validateOrgAlias(org_alias);

    return (
      isRequesting ||
      !requestor_first_name ||
      !requestor_last_name ||
      !requestor_email ||
      !isValidOrgAlias ||
      !org_name ||
      !isvalidEmail
    );
  };

  const onSubmitForm = async () => {
    setIsRequesting(true);
    setErrMessage("");
    try {
      const res = await post("/org_requests", input);
      setIsRequesting(false);
      if (res.status !== 201) {
        return setErrMessage(
          res.data.detail || "Cannot create new organization"
        );
      }
      setIsSuccessful(true);
    } catch (error) {
      setIsRequesting(false);
    }
    return null;
  };

  return (
    <Grid
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isSuccessful && (
        <Box
          sx={{
            background: "#d3d3d347",
            padding: "15px",
            borderRadius: "8px",
          }}
        >
          <h2>Request Successful</h2>
          <p>
            Check your email for a confirmation link. It may take several
            minutes to arrive.
          </p>
          <p>
            Back to{" "}
            <Link
              component={RouterLink}
              to="/login"
              sx={{
                color: blue[500],
              }}
            >
              Login
            </Link>{" "}
            page
          </p>
        </Box>
      )}
      {!isSuccessful && (
        <Box
          sx={{
            border: `1px solid ${grey[300]}`,
            padding: "15px",
            borderRadius: "4px",
            maxWidth: 400,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              textAlign: "center",
              padding: "0 15% 20px",
            }}
          >
            Create your organization to get started with Stel.
          </Typography>
          <Box
            sx={{
              display: "flex",
            }}
          >
            <TextField
              name="requestor_first_name"
              size="small"
              variant="outlined"
              placeholder="First Name"
              label="First Name"
              onChange={onChangeInput}
              value={input.requestor_first_name}
              sx={{ marginBottom: "20px", marginRight: "15px", width: "100%" }}
            />
            <TextField
              name="requestor_last_name"
              size="small"
              variant="outlined"
              placeholder="Last Name"
              label="Last Name"
              onChange={onChangeInput}
              value={input.requestor_last_name}
              sx={{ marginBottom: "20px", width: "100%" }}
            />
          </Box>
          <TextField
            name="requestor_email"
            label="Email"
            placeholder="Email"
            size="small"
            variant="outlined"
            onChange={onChangeInput}
            value={input.requestor_email}
            helperText={errEmail}
            error={errEmail}
            sx={{
              marginBottom: "20px",
              width: "100%",
              ...(errEmail && { margin: 0 }),
            }}
          />
          <TextField
            name="org_name"
            size="small"
            variant="outlined"
            label="Organization Name"
            placeholder="Organization Name"
            onChange={onChangeInput}
            value={input.org_name}
            sx={{ marginBottom: "20px", width: "100%" }}
          />
          <TextField
            name="org_alias"
            label="Organization Alias"
            placeholder="Organization Alias"
            size="small"
            variant="outlined"
            helperText="Only lowercase letters, numbers, and dashes are allowed. 20 character maximum."
            error={errOrgAlias}
            onChange={onChangeInput}
            value={input.org_alias}
            sx={{ marginBottom: "20px", width: "100%" }}
          />
          {errMessage && (
            <Typography
              variant="body2"
              sx={{
                color: red[500],
                fontStyle: "italic",
                textAlign: "center",
                marginTop: 0,
              }}
            >
              {errMessage}
            </Typography>
          )}
          <Button
            onClick={onSubmitForm}
            variant="contained"
            disabled={disableButtonSubmit()}
            color="primary"
            sx={{
              width: "100%",
            }}
          >
            {isRequesting && (
              <CircularProgress size={16} sx={{ marginRight: "10px" }} />
            )}{" "}
            Submit
          </Button>
        </Box>
      )}
    </Grid>
  );
}
export default NewOrganization;
